import { LayoutState } from '../reducers/layout.reducers';
import { createAction, props } from '@ngrx/store';

export const layoutChanged = createAction('[Layout] Changed', props<Partial<LayoutState>>());
